import { renderCatalogTooltips } from './info-tooltip.js';
import { updateCatalogItemStatus, saveCatalogItems } from './catalog-button.js';

document.addEventListener('DOMContentLoaded', function() {
  const loadMoreBtn = document.querySelector('.catalog-listing__button');
  
  if (loadMoreBtn) {

     const siteUrl = window.location.origin;

     let restUrl;

    if (siteUrl !== 'http://localhost') {
      restUrl = `${window.location.origin}/wp-json/custom/v1/load-more-listing`;
    } else {
      restUrl = `${window.location.origin}/sellerden/wp-json/custom/v1/load-more-listing`;
    }
    

    loadMoreBtn.addEventListener('click', async function(e) {
      e.preventDefault();

      const button = e.currentTarget;
      const nextPage = parseInt(button.dataset.page) + 1;
      
      button.classList.add('catalog-listing__button--loading');
      button.innerHTML = '<span class="catalog-spinner"></span> Загрузка';
      button.disabled = true;

      try {
        const response = await fetch(restUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page: nextPage,
            per_page: button.dataset.perPage || 6,
            custom_args: JSON.parse(button.dataset.args)
          })
        });

        const data = await response.json();
        
        if (data.success && data.html) {
          document.querySelector('.catalog-listing__list').insertAdjacentHTML('beforeend', data.html);
          button.dataset.page = nextPage;

          // Инициализация новых элементов
          renderCatalogTooltips();
          updateCatalogItemStatus();
          saveCatalogItems();
          
          if (nextPage >= data.maxPages) {
            button.remove();
          }
        }
      } catch (error) {
        console.error('Load more error:', error);
        // Добавьте обработку ошибки
      } finally {
        button.classList.remove('catalog-listing__button--loading');
        button.textContent = 'Загрузить еще';
        button.disabled = false;
      }
    });
  }
});